<mat-form-field class="w-100">
  <mat-label>{{ label }}</mat-label>
  <input type="text"
         matInput
         name="search"
         [formControl]="control"
         (change)="onSearch()" />
  <div matSuffix class="d-flex">
    <button mat-icon-button
      color="primary"
      type="button"
      (click)="onSearch()">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-icon-button
        color="primary"
        type="button"
        (click)="onReset()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</mat-form-field>
